import React, { useEffect, useState } from "react";
import Banner from "./pages/Banner";
// import Quest from "./pages/Quest";
import Leaderboard from "./pages/Leaderboard";
import Social from "./pages/Social";
import Daily from "./pages/Daily";
import Monthly from "./pages/Monthly";
import Weekly from "./pages/Weekly";
import NewQuest from "./pages/NewQuest";
import Questions from "./pages/Questions";
import { getLaderBoardDataMonthAndWeek } from "../services/api";

const Main = () => {
    const [nav, setNav] = useState("quests");

    return (
        <div>
            <Banner />

            <div className="w-full h-[74px] bg-[#232323] mb-8 flex justify-start items-center pl-0 sm:pl-5">
                <div
                    className={` border-b-[6px] ${
                        nav === "quests"
                            ? "bg-[#FE61BD26] border-[#FE61BD]"
                            : "bg-transparent border-transparent"
                    } min-w-[150px] sm:min-w-[220px] text-[#bcbcbc] text-[20px] font-semibold leading-[30px] py-[20px] h-full cursor-pointer`}
                    onClick={() => setNav("quests")}
                >
                    Quests
                </div>
                <div
                    className={` border-b-[6px] ${
                        nav === "leaderboard"
                            ? "bg-[#FE61BD26] border-[#FE61BD]"
                            : "bg-transparent border-transparent"
                    } min-w-[150px] sm:min-w-[220px] text-[#bcbcbc] text-[20px] font-semibold leading-[30px] py-[20px] h-full cursor-pointer`}
                    onClick={() => setNav("leaderboard")}
                >
                    Leaderboard
                </div>
            </div>
            {nav === "quests" && (
                <>
                    {" "}
                    <div className="flex flex-col sm:flex-row items-start justify-center gap-8 w-full h-full">
                        {/* <Quest className="w-full sm:w-[54%] h-full bg-[#232323] rounded-[24px] p-[20px] flex flex-col items-start justify-start" /> */}
                        <NewQuest className="w-full sm:w-[54%] h-full bg-[#232323] rounded-[24px] p-[20px] flex flex-col items-start justify-start" />
                        <div className="w-full sm:w-[44%] flex flex-col items-start justify-start gap-9">
                            <Leaderboard
                                setNav={setNav}
                                className="w-full h-full bg-[#232323] rounded-[24px] py-[28px] lg:py-[32px] xl:py-[35px] px-[40px] flex flex-col items-start justify-start"
                            />
                            <Social className="w-full h-full bg-[#232323] rounded-[24px] py-[28px] lg:py-[32px] xl:py-[35px] px-[40px] flex flex-col items-start justify-start" />
                        </div>
                    </div>
                    <Questions className="mt-10 sm:mt-4 w-full min-h-[320px] bg-[#232323] rounded-[24px] p-[38px]" />
                </>
            )}
            {nav === "leaderboard" && (
                <div className="flex flex-col sm:flex-row items-start justify-center gap-8 w-full h-full">
                    <Daily className="w-full sm:w-[54%] h-full bg-[#232323] rounded-[24px] p-[10px] sm:p-[20px] flex flex-col items-start justify-start" />
                    <div className="w-full sm:w-[44%] flex flex-col items-start justify-start gap-4">
                        <Monthly className="w-full h-full bg-[#232323] rounded-[24px] py-[20px] px-[10px] sm:px-[40px] flex flex-col items-start justify-start" />
                        <Weekly className="w-full h-full bg-[#232323] rounded-[24px] py-[20px] px-[10px] sm:px-[40px] flex flex-col items-start justify-start" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Main;
